import { axios } from "~/plugins/request"

export const state = () => {
	return {}
}
export const mutations = {}

export const actions = {
  findAllPro({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/service/condition/selectProvinceList`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  selectAll({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/batchManagement/selectAll`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
}
